import React, { useEffect, useRef, useState } from 'react';
import { deleteCache } from 'api/fetch-api-client';
import { cdnFilenameRegexp } from 'common/constants/regexp';
import { ImageFallbackProps } from './types';

export const ImageWithFallback = ({
  altText = 'Реклама',
  className,
  fallbackSrc,
  redisHash,
  src,
}: ImageFallbackProps) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);
  const hasDeletedCacheRef = useRef(false);

  const handleError = () => {
    if (!hasError && fallbackSrc) {
      setImgSrc(fallbackSrc);
      setHasError(true);
    }
  };

  useEffect(() => {
    if (redisHash && hasError && !hasDeletedCacheRef.current) {
      const redisKey = src?.match(cdnFilenameRegexp)?.groups?.filename;
      if (redisKey) {
        deleteCache(redisHash, redisKey);
      }
      hasDeletedCacheRef.current = true;
    }
  }, [hasError, redisHash, src]);

  return <img className={className} src={imgSrc} alt={altText} loading="lazy" onError={handleError} />;
};
